/**
 * StandardRadioGroup - стандартный компонент для фильтров с радиокнопками
 *
 * Централизует стили и поведение всех RadioGroup в FilterSidebar.
 * Автоматически добавляет отступ снизу для правильного расстояния между фильтрами.
 *
 * Использование:
 * <StandardRadioGroup value={value} onChange={onChange}>
 *     <FormControlLabel control={<Radio />} label="Option 1" />
 *     <FormControlLabel control={<Radio />} label="Option 2" />
 * </StandardRadioGroup>
 */

import React from 'react';
import RadioGroup from '@material-ui/core/RadioGroup';
import PropTypes from 'prop-types';

const StandardRadioGroup = ({
    children,
    value,
    onChange,
    className,
    ...props
}) => (
    <RadioGroup
        // Радиогруппы — управляющий контрол, не условное обозначение: при экспорте
        // карты в растр (DA-15019) они не рендерятся.
        data-export-omit=""
        value={value}
        onChange={onChange}
        style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
            margin: 0,
            marginBottom: '10px',
            paddingLeft: '5px',
            paddingRight: '10px',
            width: '100%',
            minWidth: 0,
            maxWidth: '100%',
            overflow: 'hidden',
            boxSizing: 'border-box',
        }}
        className={className}
        {...props}
    >
        {children}
    </RadioGroup>
);

StandardRadioGroup.propTypes = {
    children: PropTypes.node.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func,
    className: PropTypes.string,
};

export default StandardRadioGroup;
